/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-children-prop */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/prop-types */
import React from 'react';
import { Box, Center, Flex, SkeletonCircle, Image, Skeleton } from '@chakra-ui/react';
import DashboardCard from '../DashboardCard';
import DashboardContainer from '../DashboardContainer';
import NoData from '../NoData';
import greenArrowUp from '../../assets/images/greenArrowUp.png';
import redArrowDown from '../../assets/images/redArrowDown.png';
import CircularChart from '../Charts/CircularChart';
import { colors } from '../../theme';
import ColumnChart from '../Charts/ColumnChart';
import ChartCardTitle from '../ChartCardTitle';
// import StackChart from '../Charts/StackChart';
import {
  calculatePercentage,
  // calculateRelativePercentage,
  calculateTrendPercentage,
  numberFormatter
} from '../../utils/helper';
import {
  // CIRCULAR_CHART_COLORS,
  DASHBOARD_TEXT_COLOR,
  HEADER_COLORS,
  NEW_CHART_COLOR
} from '../../constants';
import DonuteChart from '../Charts/DonuteChart';
import DonutChartImageContainer from '../DonutChartImageContainer';

const DashboardTopCard = function ({
  activityTopCardData,
  workforceTopCardPoolUti,
  workforceTopCardShiftUti,
  workforceTopCardLOS,
  leaverTopCardLos,
  // leaversTopCardPoolUti,
  leaverTopCardCounts
  // isDataAvailable
}) {
  const total = workforceTopCardShiftUti?.result?.reduce((prev, curr) => prev + curr, 0);
  // const workforceLosArray = workforceTopCardLOS?.result?.rows?.map((d) => d.data[0]);
  let total1 = 0;
  workforceTopCardLOS?.result?.rows?.forEach((element) => {
    total1 += element.data[0];
  });
  // const leaverLosArray = leaverTopCardLos?.result?.rows?.map((d) => d.data[0]);
  let total2 = 0;
  leaverTopCardLos?.result?.rows?.forEach((element) => {
    total2 += element.data[0];
  });
  return (
    <Flex mt={25}>
      <DashboardContainer header="Activity" color={HEADER_COLORS.ACTIVITY_COLOR}>
        <Flex>
          {/* mb="5px"  mr="5px" */}
          <DashboardCard
            m="5px"
            borderRadius="10px"
            boxShadow="rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px">
            <Box textOverflow="ellipsis" whiteSpace="nowrap" overflow="hidden">
              <Center display="flex" flexDirection="column" pos="absolute" right="51.5%">
                {activityTopCardData?.result?.is_past_range_value_required &&
                  (activityTopCardData?.result?.shift_fullfilment?.current_range?.fulfilled >=
                  activityTopCardData?.result?.shift_fullfilment?.past_range?.fulfilled ? (
                    <Box mt={2}>
                      <Image src={greenArrowUp} height={6} />
                    </Box>
                  ) : (
                    <Box mt={2}>
                      <Image src={redArrowDown} height={6} />
                    </Box>
                  ))}
                {activityTopCardData?.result?.is_past_range_value_required && (
                  <Box
                    mt={1}
                    fontSize="md"
                    color={
                      activityTopCardData?.result?.shift_fullfilment?.current_range?.fulfilled >=
                      activityTopCardData?.result?.shift_fullfilment?.past_range?.fulfilled
                        ? colors.main.positiveGreen
                        : colors.main.negativeRed
                    }>
                    {activityTopCardData?.result?.shift_fullfilment?.current_range.fulfilled ===
                      0 ||
                    activityTopCardData?.result?.shift_fullfilment?.past_range.fulfilled === 0
                      ? 100
                      : Math.abs(
                          calculatePercentage(
                            activityTopCardData?.result?.shift_fullfilment?.current_range.fulfilled,
                            activityTopCardData?.result?.shift_fullfilment?.current_range.lost
                          ) -
                            calculatePercentage(
                              activityTopCardData?.result?.shift_fullfilment?.past_range.fulfilled,
                              activityTopCardData?.result?.shift_fullfilment?.past_range.lost
                            )
                        )}
                    %
                  </Box>
                )}
              </Center>
              <ChartCardTitle title="Shift Fulfilment" label="Requested vs Fulfilled %" />
              <Box>
                {activityTopCardData?.is_data_available ? (
                  <>
                    {activityTopCardData &&
                    activityTopCardData?.result?.shift_fullfilment?.current_range ? (
                      <>
                        <CircularChart
                          // value={calculatePercentage(
                          // activityTopCardData?.result?.shift_fullfilment?.current_range
                          //   ?.fulfilled,
                          //   activityTopCardData?.result?.shift_fullfilment?.current_range?.lost
                          // )}
                          // displayValue={calculatePercentage(
                          //   activityTopCardData?.result?.shift_fullfilment?.current_range
                          //     ?.fulfilled,
                          //   activityTopCardData?.result?.shift_fullfilment?.current_range?.lost
                          // )}
                          value={
                            activityTopCardData?.result?.shift_fullfilment?.current_range
                              ?.percentage
                          }
                          displayValue={
                            activityTopCardData?.result?.shift_fullfilment?.current_range
                              ?.percentage
                          }
                          // value={Math.round(
                          //   (100 * activityTopCardData?.shift_fullfilment?.current_range?.fulfilled) /
                          //   (activityTopCardData?.shift_fullfilment?.current_range?.fulfilled +
                          //     activityTopCardData?.shift_fullfilment?.current_range?.lost) || 100
                          // )}
                          // displayValue={Math.round(
                          //   (100 * activityTopCardData?.shift_fullfilment?.current_range?.fulfilled) /
                          //   (activityTopCardData?.shift_fullfilment?.current_range?.fulfilled +
                          //     activityTopCardData?.shift_fullfilment?.current_range?.lost) || 100
                          // )}
                          max={100}
                          styles={{
                            pathColor: NEW_CHART_COLOR.BLUE,
                            trailColor: colors.main.blueBackground
                          }}
                          maxW="220px"
                          valueType="%"
                          extraLabel="Fulfilled"
                          extraCount={
                            activityTopCardData?.result?.shift_fullfilment?.current_range?.fulfilled
                          }
                          label="Requested"
                          count={
                            activityTopCardData?.result?.shift_fullfilment?.current_range?.requested
                          }
                          // positive={
                          //   activityTopCardData?.result?.shift_fullfilment?.current_range
                          //     ?.fulfilled >=
                          //   activityTopCardData?.result?.shift_fullfilment?.past_range?.fulfilled
                          //     ? true
                          //     : false
                          // }
                          // difference={calculateRelativePercentage(
                          //   activityTopCardData?.result?.shift_fullfilment?.current_range.fulfilled,
                          //   activityTopCardData?.result?.shift_fullfilment?.past_range.fulfilled
                          // )}
                          // isIndicatorsVisible={
                          //   activityTopCardData?.result?.is_past_range_value_required
                          // }
                        />
                      </>
                    ) : (
                      <SkeletonCircle size="40" margin="auto" />
                    )}
                  </>
                ) : (
                  <NoData height="130px" width="130px" />
                )}
              </Box>
            </Box>
          </DashboardCard>
          {/* mb="5px" */}
          <DashboardCard
            m="5px"
            borderRadius="10px"
            boxShadow="rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px">
            <Box>
              {activityTopCardData?.result?.is_past_range_value_required && (
                <>
                  <Center display="flex" flexDirection="column" pos="absolute" right={3}>
                    <Center>
                      {activityTopCardData?.result?.shift_lost.current_range.count >=
                      activityTopCardData?.result.shift_lost.past_range.count ? (
                        <Image src={greenArrowUp} height={6} />
                      ) : (
                        <Image src={redArrowDown} height={6} />
                      )}
                    </Center>
                    <Center
                      mt={1}
                      fontSize="md"
                      color={
                        activityTopCardData?.result?.shift_lost.current_range?.count >=
                        activityTopCardData?.result?.shift_lost.past_range?.count
                          ? colors.main.positiveGreen
                          : colors.main.negativeRed
                      }>
                      {calculateTrendPercentage(
                        activityTopCardData?.result?.shift_lost?.current_range?.count,
                        activityTopCardData?.result?.shift_lost.past_range?.count
                      )}
                      %
                    </Center>{' '}
                  </Center>
                </>
              )}
              <ChartCardTitle
                title="Unfulfilled Shifts"
                label="Total Requested minus Total Fulfilled"
              />

              <Box margin="auto">
                {activityTopCardData?.is_data_available ? (
                  <>
                    {activityTopCardData.is_data_available ? (
                      <>
                        <Center
                          fontSize="60px"
                          h="227px"
                          // mt={activityTopCardData?.result?.is_past_range_value_required ? 8 : 8}
                          color={DASHBOARD_TEXT_COLOR.TEXT_COLOR}>
                          {/* {Math.round(
                            activityTopCardData?.result?.shift_lost.current_range.count
                          ).toString().length > 6
                            ? numberFormatter(
                                activityTopCardData?.result?.shift_lost.current_range.count
                              )
                            : activityTopCardData?.result?.shift_lost.current_range.count} */}
                          {activityTopCardData?.result?.shift_fullfilment?.current_range?.lost}
                        </Center>
                      </>
                    ) : (
                      <Skeleton h="200px" w="100%" />
                    )}
                  </>
                ) : (
                  <NoData height="130px" width="130px" />
                )}
              </Box>
            </Box>
          </DashboardCard>
        </Flex>
        <Flex>
          {/* mr="5px" */}
          <DashboardCard
            m="5px"
            borderRadius="10px"
            boxShadow="rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px"
            position="relative">
            <Box textOverflow="ellipsis" whiteSpace="nowrap">
              <ChartCardTitle title="Spend" label="Breakdown Of Standard And Overtime Spend" />
              {/* <Tooltip label="Spent">
                <Center mt={2}>Spent</Center>
              </Tooltip> */}
              <Box>
                {activityTopCardData?.is_data_available ? (
                  activityTopCardData ? (
                    <DonutChartImageContainer
                      difference={calculateTrendPercentage(
                        activityTopCardData?.result?.total_spent?.current_range?.standardTotal +
                          activityTopCardData?.result?.total_spent?.current_range?.overtimeTotal +
                          activityTopCardData?.result?.total_spent?.current_range?.bhTotal +
                          activityTopCardData?.result?.total_spent?.current_range?.suspensionTotal +
                          activityTopCardData?.result?.total_spent?.current_range?.nspTotal +
                          activityTopCardData?.result?.total_spent?.current_range?.trainingTotal +
                          activityTopCardData?.result?.total_spent?.current_range
                            ?.standardBonusTotal +
                          activityTopCardData?.result?.total_spent?.current_range
                            ?.specialBonusTotal +
                          activityTopCardData?.result?.total_spent?.current_range?.weekendTotal +
                          activityTopCardData?.result?.total_spent?.current_range
                            ?.internalStandardTotal +
                          activityTopCardData?.result?.total_spent?.current_range
                            ?.internalOvertimeTotal +
                          activityTopCardData?.result?.total_spent?.current_range
                            ?.internalPermanentTotal +
                          activityTopCardData?.result?.total_spent?.current_range.wtrCosts,

                        activityTopCardData?.result?.total_spent?.past_range?.standardTotal +
                          activityTopCardData?.result?.total_spent?.past_range?.overtimeTotal +
                          activityTopCardData?.result?.total_spent?.past_range?.bhTotal +
                          activityTopCardData?.result?.total_spent?.past_range?.suspensionTotal +
                          activityTopCardData?.result?.total_spent?.past_range?.nspTotal +
                          activityTopCardData?.result?.total_spent?.past_range?.trainingTotal +
                          activityTopCardData?.result?.total_spent?.past_range?.standardBonusTotal +
                          activityTopCardData?.result?.total_spent?.past_range?.specialBonusTotal +
                          activityTopCardData?.result?.total_spent?.past_range?.weekendTotal +
                          activityTopCardData?.result?.total_spent?.past_range
                            ?.internalStandardTotal +
                          activityTopCardData?.result?.total_spent?.past_range
                            ?.internalOvertimeTotal +
                          activityTopCardData?.result?.total_spent?.past_range
                            ?.internalPermanentTotal +
                          activityTopCardData?.result?.total_spent?.past_range?.wtrCosts
                      )}
                      isIndicatorsVisible={
                        activityTopCardData?.result?.is_past_range_value_required
                      }
                      positive={
                        activityTopCardData?.result?.total_spent?.current_range?.standardTotal >=
                        activityTopCardData?.result?.total_spent?.past_range?.standardTotal
                          ? true
                          : false
                      }
                      children={
                        <DonuteChart
                          series={[
                            activityTopCardData?.result?.total_spent?.current_range?.standardTotal,
                            activityTopCardData?.result?.total_spent?.current_range?.overtimeTotal,
                            activityTopCardData?.result?.total_spent?.current_range?.bhTotal,
                            activityTopCardData?.result?.total_spent?.current_range
                              ?.suspensionTotal,
                            activityTopCardData?.result?.total_spent?.current_range?.nspTotal,
                            activityTopCardData?.result?.total_spent?.current_range?.trainingTotal,
                            activityTopCardData?.result?.total_spent?.current_range
                              ?.standardBonusTotal,
                            activityTopCardData?.result?.total_spent?.current_range
                              ?.specialBonusTotal,
                            activityTopCardData?.result?.total_spent?.current_range?.weekendTotal,
                            activityTopCardData?.result?.total_spent?.current_range
                              ?.internalStandardTotal,
                            activityTopCardData?.result?.total_spent?.current_range
                              ?.internalOvertimeTotal,
                            activityTopCardData?.result?.total_spent?.current_range
                              ?.internalPermanentTotal,
                            activityTopCardData?.result?.total_spent?.current_range?.wtrCosts
                          ]}
                          valueType="£"
                          labels={[
                            'Standard',
                            'Overtime',
                            'Bh',
                            'Suspension',
                            'SP',
                            'Training',
                            'Standard Bonus',
                            'Special Bonus',
                            'Weekend',
                            'Internal Standard',
                            'Internal Overtime',
                            'Internal Permanent',
                            'WTR Costs'
                          ]}
                          // max={
                          //   activityTopCardData?.result?.total_spent?.current_range?.basic +
                          //   activityTopCardData?.result?.total_spent?.current_range?.other
                          // }
                          // displayValue={Math.round(
                          //   activityTopCardData?.result?.total_spent?.current_range?.basic +
                          //     activityTopCardData?.result?.total_spent?.current_range?.other || 0
                          // )}
                          // styles={{
                          //   pathColor: CIRCULAR_CHART_COLORS.PATH_COLOR,
                          //   trailColor: CIRCULAR_CHART_COLORS.TRAIL_COLOR
                          // }}
                          // maxW="220px"
                          // positive={
                          //   activityTopCardData?.result?.total_spent?.current_range?.basic >=
                          //   activityTopCardData?.result?.total_spent?.past_range?.basic
                          //     ? true
                          //     : false
                          // }
                          // difference={calculateRelativePercentage(
                          //   activityTopCardData?.result?.total_spent?.current_range?.basic +
                          //     activityTopCardData?.result?.total_spent?.current_range?.other,
                          //   activityTopCardData?.result?.total_spent?.past_range?.basic +
                          //     activityTopCardData?.result?.total_spent?.past_range?.other
                          // )}
                          // isIndicatorsVisible={
                          //   activityTopCardData?.result?.is_past_range_value_required
                          // }
                        />
                      }
                    />
                  ) : (
                    <SkeletonCircle size="40" margin="auto" />
                  )
                ) : (
                  <NoData height="130px" width="130px" />
                )}
              </Box>
            </Box>
          </DashboardCard>
          {/* mb="5px"  */}
          <DashboardCard
            m="5px"
            borderRadius="10px"
            boxShadow="rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px"
            position="relative">
            <Box textOverflow="ellipsis" whiteSpace="nowrap">
              <ChartCardTitle title="Hours" label="Breakdown Of Standard And Overtime Hours" />
              {/* <Tooltip label="Hours">
                <Center mt={2}>Hours</Center>
              </Tooltip> */}
              <Box>
                {activityTopCardData?.is_data_available ? (
                  <>
                    {activityTopCardData ? (
                      <DonutChartImageContainer
                        positive={
                          activityTopCardData?.result?.total_hours?.current_range?.standardHour >=
                          activityTopCardData?.result?.total_hours?.past_range?.standardHour
                            ? true
                            : false
                        }
                        difference={calculateTrendPercentage(
                          activityTopCardData?.result?.total_hours?.current_range?.standardHour +
                            activityTopCardData?.result?.total_hours?.current_range?.overtimeHour +
                            activityTopCardData?.result?.total_hours?.current_range?.bhHour +
                            activityTopCardData?.result?.total_hours?.current_range?.nspHour +
                            activityTopCardData?.result?.total_hours?.current_range?.trainingHour +
                            activityTopCardData?.result?.total_hours?.current_range
                              ?.suspensionHour +
                            activityTopCardData?.result?.total_hours?.current_range
                              ?.standardBonusHour +
                            activityTopCardData?.result?.total_hours?.current_range
                              ?.specialBonusHour +
                            activityTopCardData?.result?.total_hours?.current_range?.weekendHour +
                            activityTopCardData?.result?.total_hours?.current_range
                              ?.internalStandardHour +
                            activityTopCardData?.result?.total_hours?.current_range
                              ?.internalOvertimeHour +
                            activityTopCardData?.result?.total_hours?.current_range
                              ?.internalPermanentHour,

                          activityTopCardData?.result?.total_hours?.past_range?.standardHour +
                            activityTopCardData?.result?.total_hours?.past_range?.overtimeHour +
                            activityTopCardData?.result?.total_hours?.past_range?.bhHour +
                            activityTopCardData?.result?.total_hours?.past_range?.nspHour +
                            activityTopCardData?.result?.total_hours?.past_range?.trainingHour +
                            activityTopCardData?.result?.total_hours?.past_range?.suspensionHour +
                            activityTopCardData?.result?.total_hours?.past_range
                              ?.standardBonusHour +
                            activityTopCardData?.result?.total_hours?.past_range?.specialBonusHour +
                            activityTopCardData?.result?.total_hours?.past_range?.weekendHour +
                            activityTopCardData?.result?.total_hours?.past_range
                              ?.internalStandardHour +
                            activityTopCardData?.result?.total_hours?.past_range
                              ?.internalOvertimeHour +
                            activityTopCardData?.result?.total_hours?.past_range
                              ?.internalPermanentHour
                        )}
                        isIndicatorsVisible={
                          activityTopCardData?.result?.is_past_range_value_required
                        }
                        children={
                          <DonuteChart
                            series={[
                              activityTopCardData?.result?.total_hours?.current_range?.standardHour,
                              activityTopCardData?.result?.total_hours?.current_range?.overtimeHour,
                              activityTopCardData?.result?.total_hours?.current_range?.bhHour,
                              activityTopCardData?.result?.total_hours?.current_range?.nspHour,
                              activityTopCardData?.result?.total_hours?.current_range?.trainingHour,
                              activityTopCardData?.result?.total_hours?.current_range
                                ?.suspensionHour,
                              activityTopCardData?.result?.total_hours?.current_range
                                ?.standardBonusHour,
                              activityTopCardData?.result?.total_hours?.current_range
                                ?.specialBonusHour,
                              activityTopCardData?.result?.total_hours?.current_range?.weekendHour,
                              activityTopCardData?.result?.total_hours?.current_range
                                ?.internalStandardHour,
                              activityTopCardData?.result?.total_hours?.current_range
                                ?.internalOvertimeHour,
                              activityTopCardData?.result?.total_hours?.current_range
                                ?.internalPermanentHour
                            ]}
                            labels={[
                              'Standard',
                              'Overtime',
                              'Bh',
                              'SP',
                              'Training',
                              'Suspension',
                              'Standard Bonus',
                              'Special Bonus',
                              'Weekend',
                              'Internal Standard',
                              'Internal Overtime',
                              'Internal Permanent'
                            ]}
                            // valueType="£"
                          />
                        }
                      />
                    ) : (
                      // <CircularChart
                      //   value={activityTopCardData?.result?.total_hours?.current_range?.basic || 0}
                      //   max={
                      //     activityTopCardData?.result?.total_hours?.current_range?.basic +
                      //     activityTopCardData?.result?.total_hours?.current_range?.other
                      //   }
                      //   displayValue={Math.round(
                      //     activityTopCardData?.result?.total_hours?.current_range?.basic +
                      //       activityTopCardData?.result?.total_hours?.current_range?.other || 0
                      //   )}
                      //   styles={{
                      //     pathColor: CIRCULAR_CHART_COLORS.PATH_COLOR,
                      //     trailColor: CIRCULAR_CHART_COLORS.TRAIL_COLOR
                      //   }}
                      //   maxW="220px"
                      // positive={
                      //   activityTopCardData?.result?.total_hours?.current_range?.basic >=
                      //   activityTopCardData?.result?.total_hours?.past_range?.basic
                      //     ? true
                      //     : false
                      // }
                      // difference={calculateRelativePercentage(
                      //   activityTopCardData?.result?.total_hours?.current_range?.basic +
                      //     activityTopCardData?.result?.total_hours?.current_range?.other,
                      //   activityTopCardData?.result?.total_hours?.past_range?.basic +
                      //     activityTopCardData?.result?.total_hours?.past_range?.other
                      // )}
                      // isIndicatorsVisible={
                      //   activityTopCardData?.result?.is_past_range_value_required
                      // }
                      // />
                      <SkeletonCircle size="40" margin="auto" />
                    )}
                  </>
                ) : (
                  <NoData height="130px" width="130px" />
                )}
              </Box>
            </Box>
          </DashboardCard>
        </Flex>
      </DashboardContainer>
      <DashboardContainer header="Workforce" color={HEADER_COLORS.ACTIVITY_COLOR}>
        <Flex>
          {/* mb="5px" mr="5px"   */}
          <DashboardCard
            m="5px"
            borderRadius="10px"
            boxShadow="rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px">
            <ChartCardTitle title="Shift Utilisation" label="Total Number Of Shifts Per Worker" />
            {/* <Tooltip label="Shift Utilisation">
                <Center>Shift Utilisation</Center>
              </Tooltip> */}
            {/* <Flex justifyContent="center" alignItems="center" height="190px"> */}
            {workforceTopCardShiftUti?.is_data_available ? (
              <>
                {workforceTopCardShiftUti && workforceTopCardShiftUti?.result?.length > 0 ? (
                  <ColumnChart
                    colors={[colors.main.primary]}
                    series={[
                      {
                        data: workforceTopCardShiftUti?.result
                      }
                    ]}
                    categories={[1, 2, 3, 4, 5, 6, 7]}
                    header=""
                    customColor={false}
                    height="80%"
                    categoriesVisible
                    percentage={
                      total > 0
                        ? workforceTopCardShiftUti?.result?.map((d) => {
                            return numberFormatter((d / total) * 100);
                          })
                        : Array(workforceTopCardShiftUti?.result?.length).fill(0)
                    }
                  />
                ) : (
                  <Skeleton h="200px" w="100%" />
                )}
              </>
            ) : (
              <NoData height="130px" width="130px" />
            )}
            {/* </Flex> */}
          </DashboardCard>
          {/* mb="5px"  */}
          <DashboardCard
            m="5px"
            borderRadius="10px"
            boxShadow="rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px">
            <Box textOverflow="ellipsis" whiteSpace="nowrap" overflow="hidden">
              <Center display="flex" flexDir="column" pos="absolute" right={3} mt={2}>
                {workforceTopCardPoolUti?.result?.is_past_range_value_required &&
                  (workforceTopCardPoolUti?.result?.current_range?.total_count >=
                  workforceTopCardPoolUti?.result?.current_range?.last_range?.total_count ? (
                    <Center>
                      <Image src={greenArrowUp} height={6} />
                    </Center>
                  ) : (
                    <Center>
                      <Image src={redArrowDown} height={6} />
                    </Center>
                  ))}
                {workforceTopCardPoolUti?.result?.is_past_range_value_required && (
                  <Center
                    mt={1}
                    fontSize="md"
                    color={
                      workforceTopCardPoolUti?.result?.current_range?.total_count >=
                      workforceTopCardPoolUti?.result?.current_range?.last_range?.total_count
                        ? colors.main.positiveGreen
                        : colors.main.negativeRed
                    }>
                    {workforceTopCardPoolUti?.result?.current_range?.active_count === 0 ||
                    workforceTopCardPoolUti?.result?.last_range?.active_count === 0
                      ? 100
                      : Math.abs(
                          calculatePercentage(
                            workforceTopCardPoolUti?.result?.current_range?.active_count,
                            workforceTopCardPoolUti?.result?.current_range?.total_count -
                              workforceTopCardPoolUti?.result?.current_range?.active_count
                          ) -
                            calculatePercentage(
                              workforceTopCardPoolUti?.result?.last_range?.active_count,
                              workforceTopCardPoolUti?.result?.last_range?.total_count -
                                workforceTopCardPoolUti?.result?.last_range?.active_count
                            )
                        )}
                    %
                  </Center>
                )}
              </Center>
              <ChartCardTitle title="Pool Utilisation" label="Active Workers vs Declared Pool" />
              {/* <Tooltip label="Pool Utilisasation">
                <Center>Pool Utilisasation</Center>
              </Tooltip> */}
              <Box>
                {workforceTopCardPoolUti?.is_data_available ? (
                  <>
                    {workforceTopCardPoolUti?.result?.current_range?.active_count > -1 ? (
                      <CircularChart
                        value={calculatePercentage(
                          workforceTopCardPoolUti?.result?.current_range?.active_count,
                          workforceTopCardPoolUti?.result?.current_range?.total_count -
                            workforceTopCardPoolUti?.result?.current_range?.active_count
                        )}
                        displayValue={calculatePercentage(
                          workforceTopCardPoolUti?.result?.current_range?.active_count,
                          workforceTopCardPoolUti?.result?.current_range?.total_count -
                            workforceTopCardPoolUti?.result?.current_range?.active_count
                        )}
                        // difference={calculateRelativePercentage(
                        //   workforceTopCardPoolUti?.result?.current_range?.active_count,
                        //   workforceTopCardPoolUti?.result?.last_range?.active_count
                        // )}
                        max={100}
                        circleRatio={0.5}
                        styles={{
                          pathColor: NEW_CHART_COLOR.BLUE,
                          trailColor: colors.main.blueBackground,
                          rotation: -1 / 4
                        }}
                        maxW="220px"
                        valueType="%"
                        label="Active"
                        extraLabel="Total"
                        count={workforceTopCardPoolUti?.result?.current_range?.active_count}
                        extraCount={workforceTopCardPoolUti?.result?.current_range?.total_count}
                        // isIndicatorsVisible={
                        //   workforceTopCardPoolUti?.result?.is_past_range_value_required
                        // }
                      />
                    ) : (
                      <SkeletonCircle size="40" margin="auto" />
                    )}
                  </>
                ) : (
                  <NoData height="130px" width="130px" />
                )}
              </Box>
            </Box>
          </DashboardCard>
        </Flex>
        <Flex>
          <DashboardCard
            fullWidth
            m="5px"
            borderRadius="10px"
            boxShadow="rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px">
            <ChartCardTitle title="Length of Service" label="Breakdown Of Tenure Per Worker" />
            <Box className="stack-chart">
              {workforceTopCardLOS?.is_data_available ? (
                <>
                  {workforceTopCardLOS && workforceTopCardLOS?.result?.rows?.length > 0 ? (
                    <ColumnChart
                      header=""
                      height="165px"
                      width="100%"
                      series={[{ data: workforceTopCardLOS?.result.rows.map((d) => d.data[0]) }]}
                      categories={workforceTopCardLOS?.result.rows.map((d) => d.name)}
                      categoriesVisible
                      percentage={
                        total1 > 0
                          ? workforceTopCardLOS?.result?.rows.map((d) => {
                              return numberFormatter((d.data[0] / total1) * 100);
                            })
                          : Array(workforceTopCardLOS?.result?.rows.length).fill(0)
                      }
                      // series={workforceTopCardLOS?.result?.rows?.map((d) => d.data)}
                      // categories={workforceTopCardLOS?.result?.rows?.map((d) => d.name)}
                      // horizontal
                    />
                  ) : (
                    <Skeleton h="100px" w="100%" />
                  )}
                </>
              ) : (
                <NoData height="130px" width="130px" />
              )}
              {workforceTopCardLOS?.is_data_available && <Center fontSize="xl"># of weeks</Center>}
            </Box>
          </DashboardCard>
        </Flex>
      </DashboardContainer>
      <DashboardContainer header="Leavers" color={HEADER_COLORS.ACTIVITY_COLOR}>
        <Flex>
          {/* mb="5px" mr="5px" */}
          <DashboardCard
            m="5px"
            borderRadius="10px"
            boxShadow="rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px">
            <Box>
              <Center display="flex" flexDir="column" pos="absolute" right="51.3%">
                {leaverTopCardCounts?.result?.is_past_range_value_required && (
                  <>
                    <Center>
                      {leaverTopCardCounts?.result?.leavers_count.current_value >=
                      leaverTopCardCounts?.result?.leavers_count.past_value ? (
                        <Image src={greenArrowUp} height={6} />
                      ) : (
                        <Image src={redArrowDown} height={6} />
                      )}
                    </Center>
                    <Center
                      fontSize="md"
                      mt={1}
                      color={
                        leaverTopCardCounts?.result.leavers_count.current_value >=
                        leaverTopCardCounts?.result.leavers_count.past_value
                          ? colors.main.positiveGreen
                          : colors.main.negativeRed
                      }>
                      {calculateTrendPercentage(
                        leaverTopCardCounts?.result.leavers_count.current_value,
                        leaverTopCardCounts?.result.leavers_count.past_value
                      )}
                      %
                    </Center>
                  </>
                )}
              </Center>
              <ChartCardTitle title="Leavers" label="Number Of Confirmed Leavers" />
              <Box margin="auto">
                {leaverTopCardCounts?.is_data_available ? (
                  <>
                    {leaverTopCardCounts ? (
                      <>
                        <Center
                          fontSize="60px"
                          color={DASHBOARD_TEXT_COLOR.TEXT_COLOR}
                          // mt={leaverTopCardCounts?.result?.is_past_range_value_required ? 8 : 8}
                          h="227px">
                          {Math.round(
                            leaverTopCardCounts?.result?.leavers_count.current_value
                          ).toString().length > 6
                            ? numberFormatter(
                                leaverTopCardCounts?.result?.leavers_count.current_value
                              )
                            : leaverTopCardCounts?.result?.leavers_count.current_value}
                        </Center>
                      </>
                    ) : (
                      <Skeleton h="200px" w="100%" />
                    )}
                  </>
                ) : (
                  <NoData height="130px" width="130px" />
                )}
              </Box>
            </Box>
          </DashboardCard>
          {/* mb="5px"  */}
          <DashboardCard
            m="5px"
            borderRadius="10px"
            boxShadow="rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px">
            <Box textOverflow="ellipsis" whiteSpace="nowrap" overflow="hidden">
              <ChartCardTitle
                title="New Starter Retention"
                label="Percentage Of New Starters Remaining After 2 Weeks"
              />
              {/* <Tooltip label="Pool Utilisasation">
                <Center>Pool Utilisasation</Center>
              </Tooltip> */}
              <Box>
                {leaverTopCardCounts?.is_data_available ? (
                  <>
                    {leaverTopCardCounts?.result?.new_starter_retention?.inactive > -1 ? (
                      <CircularChart
                        value={calculatePercentage(
                          leaverTopCardCounts?.result?.new_starter_retention?.active,
                          leaverTopCardCounts?.result?.new_starter_retention?.inactive
                        )}
                        displayValue={calculatePercentage(
                          leaverTopCardCounts?.result?.new_starter_retention?.active,
                          leaverTopCardCounts?.result?.new_starter_retention?.inactive
                        )}
                        max={100}
                        circleRatio={0.5}
                        styles={{
                          pathColor: NEW_CHART_COLOR.BLUE,
                          trailColor: colors.main.blueBackground,
                          rotation: -1 / 4
                        }}
                        maxW="220px"
                        valueType="%"
                        isIndicatorsVisible={false}
                        label="New Starters"
                        count={
                          leaverTopCardCounts?.result?.new_starter_retention?.active +
                          leaverTopCardCounts?.result?.new_starter_retention?.inactive
                        }
                        extraLabel="Leavers"
                        extraCount={leaverTopCardCounts?.result?.new_starter_retention?.inactive}
                      />
                    ) : (
                      <SkeletonCircle size="40" margin="auto" />
                    )}
                  </>
                ) : (
                  <NoData height="130px" width="130px" />
                )}
              </Box>
            </Box>
          </DashboardCard>
        </Flex>
        <Flex>
          <DashboardCard
            fullWidth
            m="5px"
            borderRadius="10px"
            boxShadow="rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px">
            <ChartCardTitle title="Length of Service" label="Breakdown Of Tenure Per Worker" />
            <Box className="stack-chart">
              {leaverTopCardLos?.is_data_available ? (
                <>
                  {leaverTopCardLos &&
                  leaverTopCardLos?.result?.rows &&
                  leaverTopCardLos?.result.rows.length > 0 ? (
                    <ColumnChart
                      header=""
                      height="165px"
                      width="100%"
                      // series={leaverTopCardLos.rows}
                      series={[{ data: leaverTopCardLos?.result.rows.map((d) => d.data[0]) }]}
                      categories={leaverTopCardLos?.result.rows.map((d) => d.name)}
                      percentage={
                        total2 > 0
                          ? leaverTopCardLos?.result.rows.map((d) => {
                              return numberFormatter((d.data[0] / total2) * 100);
                            })
                          : Array(leaverTopCardLos?.result.rows.length).fill(0)
                      }
                      categoriesVisible
                    />
                  ) : (
                    <Skeleton h="100px" w="100%" />
                  )}
                </>
              ) : (
                <NoData height="130px" width="130px" />
              )}
              {leaverTopCardLos?.is_data_available && <Center fontSize="xl"># of weeks</Center>}
            </Box>
          </DashboardCard>
        </Flex>
      </DashboardContainer>
    </Flex>
  );
};

export default DashboardTopCard;
